import React from 'react';
import './blog-post.css';

import outreach from './pictures/outreach.jpg';


const Outreach = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Outreach Recap</h2>
                    <p class="site-post-meta"></p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    The outreach team was happy to be part of the NCWiT award ceremony, which celebrates 
                    9th-12th grade women, genderqueer, and non-binary students for their computing-related 
                    achievements. We enjoyed helping plan a pre-activity for this award ceremony to create an 
                    engaging atmosphere for the high schoolers. 
                    It was a great opportunity to support our next generation of women in tech!
                    <br></br>
                     
                    </p>
                    <img src={outreach} alt="Outreach group picture"/>
                   
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Outreach;

